<template>
  <header>
    <div class="navigationPlaceholder"></div>
    <div class="navigationWrapper" :class="{ scroll: scroll }">
      <div class="logo">
        <router-link :to="$route.path.indexOf('/en') === 0 ? '/en' : '/'">
          <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="-10 0 705 151.7" xml:space="preserve"><path class="claim" d="M4.3 122.3h7.2c8.6 0 14.4 5.2 14.4 12.8s-5.6 12.8-13.9 12.8H4.3v-25.6zm2.4 2.2v21.1h5c7.1 0 11.7-4.2 11.7-10.6 0-6.4-4.6-10.6-11.8-10.6H6.7zM40.3 122.2h2.4v25.6h-2.4v-25.6zM70.1 148.3c-7.4 0-13.1-5.9-13.1-13.2 0-7.4 5.8-13.3 13-13.3 3.8 0 6.6 1 8.9 3l-1.6 1.9c-2-1.5-4.2-2.5-7.3-2.5-5.8 0-10.5 4.9-10.5 11 0 6 4.7 10.9 10.8 10.9 2.3 0 4.5-.5 6.2-1.4v-9.2H79v10.8c-2.5 1.4-5.3 2-8.9 2zM93.8 122.2h2.4v25.6h-2.4v-25.6zM119.7 124.5v23.4h-2.4v-23.4h-8.6v-2.2h19.6v2.2h-8.6zM153.7 140.6h-13.1l-3 7.3h-2.5l10.8-25.6h2.8l10.8 25.6h-2.7l-3.1-7.3zm-6.6-15.8l-5.7 13.6h11.4l-5.7-13.6zM172.2 122.2h2.4v23.4h14v2.2h-16.4v-25.6zM230.1 148.3c-7.4 0-13.1-5.9-13.1-13.2 0-7.4 5.8-13.3 13-13.3 3.8 0 6.6 1 8.9 3l-1.6 1.9c-2-1.5-4.2-2.5-7.3-2.5-5.8 0-10.5 4.9-10.5 11 0 6 4.7 10.9 10.8 10.9 2.3 0 4.5-.5 6.2-1.4v-9.2h2.4v10.8c-2.4 1.4-5.2 2-8.8 2zM253.8 122.2h8.9c5.2 0 8.7 2.9 8.7 7.4 0 3.8-2.5 6.4-6.6 7.2l6.9 11H269l-6.7-10.8h-6.1v10.8h-2.4v-25.6zm2.4 2.2v10.5h6.7c3.6 0 6-2.1 6-5.2 0-3.2-2.4-5.2-6-5.2h-6.7zM309.8 135.1c0 7.3-5.8 13.2-13 13.2s-13-5.9-13-13.2c0-7.4 5.8-13.3 13-13.3s13 5.9 13 13.3zm-2.5 0c0-6.1-4.7-11-10.5-11s-10.5 4.9-10.5 11c0 6 4.7 10.9 10.5 10.9s10.5-4.9 10.5-10.9zM356.7 122.2l-8.3 25.6h-2.9l-7-22.5-7 22.5h-2.8l-8.3-25.6h2.6l7.1 22.6 6.9-22.6h3l7 22.6 7.1-22.6h2.6zM377.4 124.5v23.4H375v-23.4h-8.6v-2.2H386v2.2h-8.6zM416.9 136.1h-16.1v11.8h-2.4v-25.6h2.4v11.6h16.1v-11.6h2.4v25.6h-2.4v-11.8zM468 140.6h-13.1l-3 7.3h-2.5l10.8-25.6h2.8l10.8 25.6H471l-3-7.3zm-6.6-15.8l-5.7 13.6h11.4l-5.7-13.6zM486.5 122.3h7.2c8.6 0 14.4 5.2 14.4 12.8s-5.6 12.8-13.9 12.8h-7.8v-25.6zm2.4 2.2v21.1h5c7.1 0 11.7-4.2 11.7-10.6 0-6.4-4.6-10.6-11.8-10.6h-4.9zM529.5 145.2l8.8-23h2.5l-10 25.6H528l-10-25.6h2.7l8.8 23zM553.5 122.2h2.4v25.6h-2.4v-25.6zM585.9 127.1c-1.2-1.6-3.8-3.1-6.7-3.1-3.6 0-6 1.7-6 4.2 0 6.6 15.1 3.6 15.1 12.8 0 4.4-3.5 7.3-9 7.3-4.4 0-7.6-1.8-9.4-4.2l1.7-1.6c1.8 2.3 4.5 3.6 7.7 3.6 4.1 0 6.5-1.9 6.5-4.8 0-7.4-15-4.2-15-12.9 0-3.9 3.4-6.6 8.6-6.6 3.8 0 7 1.7 8.4 3.7l-1.9 1.6zM626.5 135.1c0 7.3-5.8 13.2-13 13.2s-13-5.9-13-13.2c0-7.4 5.8-13.3 13-13.3s13 5.9 13 13.3zm-2.5 0c0-6.1-4.7-11-10.5-11s-10.5 4.9-10.5 11c0 6 4.7 10.9 10.5 10.9s10.5-4.9 10.5-10.9zM640.8 122.2h8.9c5.2 0 8.7 2.9 8.7 7.4 0 3.8-2.5 6.4-6.6 7.2l6.9 11H656l-6.7-10.8h-6.1v10.8h-2.4v-25.6zm2.4 2.2v10.5h6.7c3.6 0 6-2.1 6-5.2 0-3.2-2.4-5.2-6-5.2h-6.7zM687.2 127.1c-1.2-1.6-3.8-3.1-6.7-3.1-3.6 0-6 1.7-6 4.2 0 6.6 15.1 3.6 15.1 12.8 0 4.4-3.5 7.3-9 7.3-4.4 0-7.6-1.8-9.4-4.2l1.7-1.6c1.8 2.3 4.5 3.6 7.7 3.6 4.1 0 6.5-1.9 6.5-4.8 0-7.4-15-4.2-15-12.9 0-3.9 3.4-6.6 8.6-6.6 3.8 0 7 1.7 8.4 3.7l-1.9 1.6z"/><g><path class="st0" d="M57.8 57.8L20.7 3.2H3.9v79.6h15.5V28.9l37.2 53.9h16.7V3.2H57.8zM165.7 50.3c0 11.3-6.7 18.8-16.9 18.8-10.3 0-17.1-7.6-17.1-18.9v-47h-15.5v47.2c0 20.5 12.9 34.2 32.4 34.2 19.6 0 32.7-13.7 32.7-34.2V3.2h-15.5v47.1zM278 57.8L240.9 3.2h-16.8v79.6h15.5V28.9l37.2 53.9h16.8V3.2H278zM432.2 17.8h23.6v65h15.5v-65H495V3.2h-62.8zM660.7 42.4l26.8-39.2H670L647.5 36H640V3.2h-15.6v79.6H640V50.5h8.2l22.3 32.3h18.9zM361.7 3.2l-32 79.6H347l23.3-60.3L381 50.2h-10.5v14.2h16l7.2 18.4h18.2l-32-79.6zM547.3 3.2l-32 79.6h17.2l23.4-60.3 10.7 27.7h-11v14.2h16.5l7.1 18.4h18.3l-32-79.6z"/></g></svg>
        </router-link>
      </div>
      <a href="#" class="toggle" @click.prevent="menuActive = !menuActive" :class="{active: menuActive}">
        <span>{{ $root.translate('close') }}</span>
      </a>
      <nav :class="{active: menuActive}" @click="menuActive = false">
        <div id="navigationSnapshot">
          <img v-if="menuActive" src="./../assets/images/Nunatak-Berg.svg" alt="Nunatak Mountains" />
        </div>
        <ul class="mainNavigation">
          <li v-for="(item, key) in menus.primary" :key="key">
            <router-link :to="item.url" :class="{ academy: item.url.indexOf('academy') != -1, active: ((item.url.indexOf('expertise') !== -1 && project && !project.acf.is_an_academy_project) || (item.url.indexOf('academy') !== -1 && project && project.acf.is_an_academy_project)) && ($route.path.indexOf('projekt') != -1 || $route.path.indexOf('project') != -1) }">{{ item.title }}</router-link>
          </li>
        </ul>
        <ul class="buttonGroup">
          <li v-for="(item, key) in options.contact_buttons" v-bind:key="key">
            <a class="buttonGroup__contactButton" :href="item.contact_button.url" target="_blank" >
              <span>{{ item.contact_button.title }}</span>
              <span class="buttonGroup__contactButton__hover"><span>{{ item.contact_button.title }}</span></span>
            </a>
          </li>
        </ul>
        <ul class="languageSelector">
          <li><a :class="{ active: language == 'de' }" :href="language == 'de' ? '#' : languageSwitch">De</a></li>
          <li><a :class="{ active: language == 'en' }" :href="language == 'en' ? '#' : languageSwitch">En</a></li>
        </ul>
        <div class="social-channels">
          <ul>
            <li><a href="https://www.linkedin.com/company/thenunatakgroup/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><path class="white" d="M200 .2C89.6.2.2 89.6.2 200S89.6 399.8 200 399.8 399.8 310.4 399.8 200 310.4.2 200 .2z" fill="#fff"/><path d="M289 273.6h-35.4v-55.4c0-13.2-.2-30.2-18.4-30.2-18.4 0-21.2 14.4-21.2 29.2v56.3h-35.4V159.7h33.9v15.6h.5c6.9-11.8 19.8-18.9 33.5-18.4 35.8 0 42.4 23.6 42.4 54.2l.1 62.5zM138.7 144.2c-11.3 0-20.5-9.2-20.5-20.5s9.2-20.5 20.5-20.5 20.5 9.2 20.5 20.5c.1 11.3-9.1 20.5-20.5 20.5m17.7 129.4H121V159.7h35.4v113.9z" fill="#4b4b4d"/></svg></a></li>
            <li><a href="https://de-de.facebook.com/TheNunatakGroup" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><path class="white" d="M200 .2C89.6.2.2 89.6.2 200S89.6 399.8 200 399.8 399.8 310.4 399.8 200 310.4.2 200 .2z" fill="#fff"/><path d="M239.9 210.7l5.8-37.5h-36v-24.4c0-10.3 5-20.3 21.2-20.3h16.4v-32S232.4 94 218.2 94c-29.7 0-49 18-49 50.5v28.6h-33v37.5h33v90.7h40.6v-90.7h30.1v.1z" fill="#4b4b4d"/></svg></a></li>
            <li><a href="https://twitter.com/thenunatakgroup" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><path class="white" d="M200 .2C89.6.2.2 89.6.2 200S89.6 399.8 200 399.8 399.8 310.4 399.8 200 310.4.2 200 .2z" fill="#fff"/><path d="M164.3 287.2c78.3 0 121.2-64.9 121.2-121.2 0-1.8 0-3.7-.1-5.5 8.3-6 15.5-13.5 21.3-22.1-7.6 3.4-15.9 5.6-24.5 6.7 8.8-5.2 15.5-13.6 18.8-23.6-8.2 4.9-17.4 8.4-27.1 10.3-7.8-8.3-18.9-13.5-31.1-13.5-23.5 0-42.6 19.1-42.6 42.6 0 3.3.4 6.6 1.1 9.7-35.4-1.7-66.8-18.8-87.8-44.5-3.7 6.3-5.7 13.6-5.7 21.4 0 14.8 7.6 27.8 18.9 35.5-7-.2-13.5-2.2-19.3-5.3v.6c0 20.6 14.7 37.9 34.1 41.8-3.6 1-7.3 1.5-11.2 1.5-2.7 0-5.4-.2-8-.7 5.4 16.9 21.2 29.2 39.8 29.6-14.6 11.5-33 18.3-52.9 18.3-3.4 0-6.8-.2-10.1-.6 18.7 11.9 41.2 19 65.2 19" fill="#4b4b4d"/></svg></a></li>
            <!-- li><a href="" target="_blank"><svg version="1.1" id="White" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 400 400" xml:space="preserve"><circle class="white" transform="rotate(-45.001 199.999 200.003)" cx="200" cy="200" r="196.8"/><path class="st0" d="M200 6.2c26.2 0 51.6 5.1 75.5 15.2 23.1 9.8 43.8 23.7 61.6 41.5 17.8 17.8 31.8 38.5 41.5 61.6 10.1 23.9 15.2 49.3 15.2 75.5s-5.1 51.6-15.2 75.5c-9.8 23.1-23.7 43.8-41.5 61.6-17.8 17.8-38.5 31.8-61.6 41.5-23.9 10.1-49.3 15.2-75.5 15.2s-51.6-5.1-75.5-15.2c-23.1-9.8-43.8-23.7-61.6-41.5-17.8-17.8-31.8-38.5-41.5-61.6C11.3 251.6 6.2 226.2 6.2 200s5.1-51.6 15.2-75.5c9.8-23.1 23.7-43.8 41.5-61.6 17.8-17.8 38.5-31.8 61.6-41.5C148.4 11.3 173.8 6.2 200 6.2m0-6C89.6.2.2 89.6.2 200S89.6 399.8 200 399.8 399.8 310.4 399.8 200 310.4.2 200 .2z"/><g><path class="st1" d="M200 117.9c26.8 0 29.9.1 40.5.6 9.8.4 15.1 2.1 18.6 3.5 4.7 1.8 8 4 11.5 7.5s5.7 6.8 7.5 11.5c1.4 3.5 3 8.8 3.5 18.6.5 10.6.6 13.7.6 40.5s-.1 29.9-.6 40.5c-.4 9.8-2.1 15.1-3.5 18.6-1.8 4.7-4 8-7.5 11.5s-6.8 5.7-11.5 7.5c-3.5 1.4-8.8 3-18.6 3.5-10.6.5-13.7.6-40.5.6s-29.9-.1-40.5-.6c-9.8-.4-15.1-2.1-18.6-3.5-4.7-1.8-8-4-11.5-7.5s-5.7-6.8-7.5-11.5c-1.4-3.5-3-8.8-3.5-18.6-.5-10.6-.6-13.7-.6-40.5s.1-29.9.6-40.5c.4-9.8 2.1-15.1 3.5-18.6 1.8-4.7 4-8 7.5-11.5s6.8-5.7 11.5-7.5c3.5-1.4 8.8-3 18.6-3.5 10.6-.5 13.7-.6 40.5-.6m0-18.1c-27.2 0-30.6.1-41.3.6-10.7.5-17.9 2.2-24.3 4.7-6.6 2.6-12.2 6-17.7 11.6-5.6 5.6-9 11.2-11.6 17.7-2.5 6.4-4.2 13.7-4.7 24.3-.5 10.7-.6 14.1-.6 41.3 0 27.2.1 30.6.6 41.3.5 10.7 2.2 17.9 4.7 24.3 2.6 6.6 6 12.2 11.6 17.7 5.6 5.6 11.2 9 17.7 11.6 6.4 2.5 13.7 4.2 24.3 4.7 10.7.5 14.1.6 41.3.6s30.6-.1 41.3-.6c10.7-.5 17.9-2.2 24.3-4.7 6.6-2.6 12.2-6 17.7-11.6s9-11.2 11.6-17.7c2.5-6.4 4.2-13.7 4.7-24.3.5-10.7.6-14.1.6-41.3s-.1-30.6-.6-41.3c-.5-10.7-2.2-17.9-4.7-24.3-2.6-6.6-6-12.2-11.6-17.7-5.6-5.6-11.2-9-17.7-11.6-6.4-2.5-13.7-4.2-24.3-4.7-10.7-.5-14.1-.6-41.3-.6z"/><path class="st1" d="M200 148.5c-28.4 0-51.5 23-51.5 51.5s23 51.5 51.5 51.5 51.5-23 51.5-51.5-23.1-51.5-51.5-51.5zm0 84.9c-18.4 0-33.4-15-33.4-33.4s15-33.4 33.4-33.4 33.4 15 33.4 33.4-15 33.4-33.4 33.4z"/><circle class="st1" cx="253.5" cy="146.5" r="12"/></g></svg></a></li -->
            <li><a href="https://www.kununu.com/de/the-nunatak-group1" target="_blank"><svg version="1.1" id="White" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 400 400" xml:space="preserve"><circle class="white" transform="rotate(-45.001 199.999 200.003)" cx="200" cy="200" r="196.8"/><path class="st0" d="M200 6.2c26.2 0 51.6 5.1 75.5 15.2 23.1 9.8 43.8 23.7 61.6 41.5 17.8 17.8 31.8 38.5 41.5 61.6 10.1 23.9 15.2 49.3 15.2 75.5s-5.1 51.6-15.2 75.5c-9.8 23.1-23.7 43.8-41.5 61.6-17.8 17.8-38.5 31.8-61.6 41.5-23.9 10.1-49.3 15.2-75.5 15.2s-51.6-5.1-75.5-15.2c-23.1-9.8-43.8-23.7-61.6-41.5-17.8-17.8-31.8-38.5-41.5-61.6C11.3 251.6 6.2 226.2 6.2 200s5.1-51.6 15.2-75.5c9.8-23.1 23.7-43.8 41.5-61.6 17.8-17.8 38.5-31.8 61.6-41.5C148.4 11.3 173.8 6.2 200 6.2m0-6C89.6.2.2 89.6.2 200S89.6 399.8 200 399.8 399.8 310.4 399.8 200 310.4.2 200 .2z"/><g><path class="st1" d="M166.6 112.6c-7.7-8.1-19.8-11.8-30.8-9.8-6.4 1-12.5 4-17.3 8.4-4.8 4.6-9.8 9.2-12.6 15.3-6.1 12.8-3.6 29.2 6.4 39.2l27.4 27.4c3 3.4 8.8 3.3 12.2.4 1.8-1.6 3.5-3.3 5.1-5.2 2.5-3.4 2.4-8.7-.7-11.8-8.8-9-17.9-17.8-26.7-26.9-3.5-3.3-4-8.8-1.9-13 1.9-3 4.7-5.5 7.3-7.9 4.1-3.8 11.1-3.4 14.9.6 7.7 7.5 15.2 15.2 22.8 22.7 2.7 2.7 5.3 6.6 9.7 6.3 4.7.7 8.1-3.1 10.9-6.2 3.3-3.4 3.5-9.4.1-12.8-9-8.9-17.9-17.8-26.8-26.7zM223.8 155.8c8.8-8.7 17.4-17.5 26.2-26.1 3.9-4.2 11.2-4.6 15.4-.6 3.2 3.2 7.4 6.2 8.2 10.9.5 3.3-.3 7-2.7 9.3-8.1 8.2-16.3 16.3-24.5 24.5-2.3 2.2-4.9 4.6-5 8.1-.7 4.9 3.2 8.5 6.5 11.5 3.5 3.4 9.8 3.3 13.1-.4l22.1-22.1c3.3-3.4 6.9-6.4 9.3-10.5 6.7-10.8 7-25.4.5-36.3-2.8-4.9-6.9-8.7-10.9-12.5-7.5-6.9-18.2-10.2-28.3-8.7-7.3 1-14.4 4.3-19.6 9.6-9.3 9.4-18.7 18.6-27.9 28.1-3.8 4.7-1 11.2 3.3 14.4 3.2 4.2 10.5 5.1 14.3.8zM182.2 241.6c-3.6 0-6.2 2.8-8.6 5.2-7.9 8-15.9 15.9-23.9 23.9-4 4.3-11.5 4.3-15.5.1-3.1-3.1-7.1-6.1-7.9-10.7-.9-4.1 1.3-8.1 4.2-10.9 8.4-8.3 16.7-16.8 25.2-25 4-3.6 3.6-10.6-.4-14.1-3-3.6-7.4-6.8-12.3-5.3-2.2.5-3.6 2.4-5.2 3.8-9 9.3-18.8 17.8-27.4 27.5-10.7 12.3-10.8 32.2-.2 44.6 4.7 5 9.4 10.5 15.8 13.5 10.3 5.2 23 4.7 33-1 5-2.6 8.6-7.1 12.7-11 7.1-7.2 14.3-14.3 21.5-21.5 3.3-3.3 3.2-9.3-.1-12.6-2.8-3.2-6.1-7.1-10.9-6.5zM283.6 229.8c-7.6-7.5-15.1-15.2-22.7-22.7-2.6-2.9-6.9-3.4-10.4-2.2-4.5 2.8-9.9 7.2-9.1 13.2-.1 3.6 2.9 5.8 5.2 8.1 7.9 7.9 15.9 15.8 23.8 23.8 3.8 3.6 4.4 10 1.3 14.2-2.4 3-5.1 5.9-8.3 8.1-4.2 2.4-9.9 1.6-13.3-1.8-9-8.9-17.9-18-26.9-26.9-3.2-3.1-8.6-2.9-12-.2-2.1 1.8-4.1 3.7-5.7 5.9-2.5 3.9-1.4 9.3 2.1 12.3 9.2 9 18.1 18.3 27.4 27.2 12.2 11 32.2 11.7 44.9 1.1 5-4.6 10.4-9.3 13.6-15.5 5.1-9.7 5.2-21.8.3-31.7-2.4-4.9-6.2-9.1-10.2-12.9z"/></g></svg></a></li>
            <li><a href="https://www.youtube.com/channel/UCvcg7aQHW31hdXQW3dp9isw" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><path class="white" d="M200 .2C89.6.2.2 89.6.2 200S89.6 399.8 200 399.8 399.8 310.4 399.8 200 310.4.2 200 .2z" fill="#fff"/><path d="M300.4 149.6c-2.4-9-9.5-16.1-18.5-18.5-16.3-4.4-81.9-4.4-81.9-4.4s-65.5 0-81.9 4.4c-9 2.4-16.1 9.5-18.5 18.5-4.4 16.3-4.4 50.4-4.4 50.4s0 34.1 4.4 50.4c2.4 9 9.5 16.1 18.5 18.5 16.3 4.4 81.9 4.4 81.9 4.4s65.5 0 81.9-4.4c9-2.4 16.1-9.5 18.5-18.5 4.4-16.3 4.4-50.4 4.4-50.4s0-34.1-4.4-50.4zM179 231.4v-62.9l54.5 31.4-54.5 31.5z" fill="#4b4b4d"/></svg></a></li>
            <li><a href="https://www.xing.com/companies/thenunatakgroupgmbh" target="_blank"><svg version="1.1" id="White" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 400 400" xml:space="preserve"><path class="white" d="M200 .2C89.6.2.2 89.6.2 200S89.6 399.8 200 399.8 399.8 310.4 399.8 200 310.4.2 200 .2z" fill="#fff"/><path class="st1" d="M123.1 135.6c-1.8 0-3.3.6-4 1.8-.8 1.3-.7 2.9.2 4.5l20 34.6v.2l-31.4 55.4c-.8 1.6-.8 3.3 0 4.5s2.1 2 3.9 2h29.5c4.4 0 6.5-3 8.1-5.7 0 0 30.7-54.3 31.9-56.4-.1-.2-20.3-35.4-20.3-35.4-1.5-2.6-3.7-5.5-8.2-5.5h-29.7zM247.2 95.2c-4.4 0-6.3 2.8-7.9 5.6 0 0-63.6 112.8-65.7 116.6.1.2 42 77 42 77 1.5 2.6 3.7 5.6 8.3 5.6h29.5c1.8 0 3.2-.7 3.9-1.9.8-1.3.8-2.9-.1-4.6l-41.6-76.1v-.2L281 101.6c.8-1.6.8-3.3.1-4.6-.8-1.2-2.1-1.9-3.9-1.9l-30 .1z"/></svg></a></li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import { pathTranslate } from '../helpers/NavigationService'; 
export default {
  name: 'Navigation',
  computed: { ...mapState({
    language: state => state.language.language,
    menus: state => state.menus.menu,
    oppositePage: state => state.routes.oppositePage,
    project: state => state.project.project,
    options: state => state.options.options,
  }),
  languageSwitch() {
      if(typeof window != 'undefined' && this.oppositePage) {
        return pathTranslate(this.oppositePage.type, this.language == 'de' ? 'en' : 'de') + this.oppositePage.slug;
      }
      else {
        return this.language == 'de' ? '/en' : '/';
      }
    }
  },
  watch: {
    language() {
      this.$store.dispatch('menus/getMenu', {
        slug: this.language == 'de' ? '28' : '29',
        name: 'primary'
      });
    }
  },
  data() {
    return {
      scroll: false,
      menuActive: false
    }
  },
  mounted() {
    this.scroll = window.scrollY > 100;
    window.addEventListener('scroll', () => this.scroll = window.scrollY > 100);
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/index';

  .buttonGroup {
    display: flex;
    gap: 1em;
    list-style: none;
    margin: 0;
    padding: 0;
    @media screen and (max-width: $medium) {
        display: flex;
        flex-direction: column;
        align-items: start;
    }


    &__contactButton {
      border: 1px solid $color;
      padding: 0.5em 0.75em;
      color: $color;
      text-decoration: none;
      display: block;
      position: relative;
      box-sizing: border-box;
      white-space: nowrap;
      @media screen and (max-width: $medium) {
        color: white;
        border-color: white;
        font-size: 1.2em;
      }
      &__hover {
        background: $color;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        bottom: 0;
        display: block;
        color: white;
        overflow: hidden;
        white-space: nowrap;
        box-sizing: border-box;
        transition: width 0.5s ease;
        span {
          display: block;
          padding: 0.5em 0.75em;
        }
      }
      &:hover {
        .buttonGroup__contactButton__hover {
          width: 100%;
        }
      }
    }
  }

  .navigationPlaceholder {
    height: 130px;
    @media screen and (max-height: 700px) {
      height: 100px;
    }
    @media screen and (max-width: $medium) {
      height: 65px;
    }
  }
  #navigationSnapshot {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100vw;
    z-index: 0;
    opacity: 1;
    transition: opacity 500ms ease 200ms;
    display: none;
    @media screen and (max-width: $medium) {
      display: block;
    }
    img {
      position: absolute;
      top: 50vh;
      left: 0;
      width: 100vw;
    }
  }
  .navigationWrapper {
    padding: 0 80px; 
    display: flex;
    align-items: center;
    height: 130px;
    background: white;
    border-bottom: 1px solid $lightgrey;
    position: fixed;
    box-sizing: border-box;
    left: 50%;
    transform: translate(-50%);
    width: 100vw;
    right: 0;
    top: 0;
    z-index: 50;
    justify-content: space-between;
    transition: height 500ms ease;

    .dark & {
      background: black !important;
      color: white;
      border-bottom: none !important;
      .logo {
        svg {
          * {
            fill: white;
          }
        }
      }
    }
    
    @media screen and (max-height: 700px) {
      height: 100px;
    }
    @media screen and (max-width: $medium) {
      height: 65px;
      padding: 0 20px;
      .logo svg {
        width: 140px !important;
      }
    }
    &.scroll {
      height: 80px;
      @media screen and (max-width: $medium) {
        height: 60px;
      }
      svg {
        transform: translate(0, 12px);
        .claim {
          opacity: 0;
          transform: scale(0.7);
        }
      }
    }
    .toggle {
      display: none;
      position: absolute;
      top: 50%;
      right: 20px;
      width: 16px;
      height: 30px;
      transform: translate(0, -50%);
      z-index: 51;
      @media screen and (max-width: $medium) {
        display: block;
      }
      span {
        position: absolute;
        right: 140%;
        color: white;
        top: 50%;
        transform: translate(20%, -50%);
        letter-spacing: 0.135em;
        opacity: 0;
        transition: opacity 300ms ease, transform 300ms ease
      }
      &.active {
        span {
          transform: translate(0, -50%);
          opacity: 1;
        }
        &:before,
        &:after {
          background: white;
          transform: translate(-50%, -50%) rotate(45deg);
          width: 20px;
        }
        &:before {
          transform: translate(-50%, -50%) rotate(-45deg);
        }
      }
      &:before,
      &:after {
        content: '';
        display: block;
        height: 4px;
        width: 16px;
        margin-right: -7px;
        background: $color;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -100%);
        transition: width 300ms ease, transform 300ms ease, background-color 400ms ease;
      }
      &:before {
        transform: translate(-50%, 100%);
      }
    }
    nav {
      display: flex;
      align-items: center;
      gap: 2em;
      @media screen and (max-width: $medium) {
        display: flex;
        align-items: start;
        //opacity: 0;
        max-width: 0;
        flex-direction: column;
        justify-content: space-between;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        background: $color;
        z-index: 50;
        color: white;
        box-sizing: border-box;
        padding: 100px 30px;
        overflow: hidden;
        transition: max-width 500ms ease, transform 500ms ease;
        transform: translate(-100px);
        width: 100%; 
        height: 100vh;
        &.active {
          max-width: 100vw;
          transform: translate(0);
          //opacity: 1;
        }
      }
    }
    svg {
      transition: transform 500ms ease;
      width: 200px;
      * {
        fill: $color;
      }
      .claim {
        transition: opacity 500ms ease, transform 500ms cubic-bezier(0.25, 0.1, 0, 1.38);
        opacity: 1;
        transform: scale(1);
        transform-origin: center center;
      }
    }
  }

  .languageSelector,
  .mainNavigation {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    
    li {
      margin: 0 1em;
      position: relative;
      a {
        color: $color;
        position: relative;
        text-decoration: none;
        font-size: 17px;
        word-wrap: none;
        white-space: nowrap;
        .dark & {
          color: white;
        }
        &:after {
          content: '';
          width: 0;
          height: 6px;
          background: $color;
          position: absolute;
          top: 125%;
          left: 0;
          transition: width 500ms ease;
          .dark & {
            background: white;
          }
          @media screen and (max-width: $medium) {
            top: 110%;
            height: 3px;
          }
        }
        &.academy {
          color: $academy;
          .dark & {
            color: white;
          }
          &:after {
            background: $academy;
            .dark & {
              background: white;
            }
          }
        }
        &.router-link-active,
        &.active,
        &:hover {
          &:after {
            width: 100%;
          }
        }
      }
      ul {
        margin: 0;
        padding: 1.5em 0;
        list-style: none;
        position: absolute;
        top: 100%;
        left: 0;
        opacity: 0;
        transform: translate(10%, 0);
        transition: opacity 500ms ease, transform 500ms ease;
        
        li {
          margin: 0;
        }
      }

      &:hover {
        ul {
          opacity: 1;
          transform: translate(0, 0);
        }
      }
    }

    @media screen and (max-width: $medium) {
      display: block;
      min-width: 50vw;
      li {
        margin: 0 0 15px;
        a {
          color: white;
          font-size: 25px;
          display: inline-block;
          &:after {
            background: white;
          }
          &.academy {
            color: white;
            margin: 1em 0;

            &:after {
              background: white;
            }
          }
        }
      }
    }
  }

  .social-channels {
    margin: 50px 0;
    display: none;
    position: relative;
    z-index: 10;
    @media screen and (max-width: $medium) {
      display: block;
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      width: 240px;
      li {
        margin: 0 15px 10px 0;
        
      }
      svg {
        width: 40px;
        height: 40px;
        .white {
          fill: white;
        }
      }
    }
  }

  .languageSelector {
    li {
      margin: 0 0 0 1em;
      a {
        &.router-link-active {
          &:after {
            content: '';
            width: 0;
          }
        }
        &:hover,
        &.active {
          &:after {
            width: 100%;
          }
        }
      }
    }
    @media screen and (max-width: $medium) {
      display: flex;
      margin: 0;
      li {
        margin: 0 1em 0 0;
      }
    }
  }

  

</style>